module.exports = __webpack_public_path__ + "img/Bitmap@2x (3).0d976a0d.png";